// Single source of truth for Pulse typography scale names, mirroring the
// `--text-<name>` font-size utilities in `packages/theme/tailwind-preset.css`.
// `cn()` registers these with tailwind-merge as font-size utilities so a
// `text-<size> text-<colour>` pair no longer collapses into one class.
//
// Lives in @glomopay/utils (not @glomopay/theme) because @glomopay/theme already
// depends on @glomopay/utils — importing theme from cn.ts would be a package cycle.
// `pulse-font-size-tokens.test.ts` in @glomopay/theme guards this list against
// drift from the CSS (that test can legally import utils; utils cannot import theme).
export const PULSE_FONT_SIZE_TOKENS = [
  'display-lg',
  'display-md',
  'display-sm',
  'heading-xl',
  'heading-lg',
  'heading-md',
  'heading-sm',
  'heading-xs',
  'body-lg',
  'body-lg-medium',
  'body-md',
  'body-md-medium',
  'body-sm',
  'body-sm-medium',
  'medium-14',
  'label-md',
  'label-sm',
  'label-xs',
  'label-overline',
] as const;
